import { PlayCircle, BookOpen, Mic } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";

const KurseSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="kurse" data-testid="kurse-section" className="section-padding bg-stone-50" ref={sectionRef}>
      <div className="container-custom">
        <div className="text-center mb-16 reveal">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-4 italic">Inspiration</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4 font-[Outfit]">Thermomix® Kurse & Community in Krefeld</h2>
          <p className="text-slate-500">Exklusive Inhalte für meine Krefelder Kunden.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 reveal reveal-delay-1">
          {/* Kochkurse with image */}
          <div className="glass-card rounded-[2rem] overflow-hidden hover-lift">
            <img src="https://customer-assets.emergentagent.com/job_thermomix-zuhause/artifacts/umqhd9qp_f92f0d90-027d-4611-b73f-be7abc4c5353.jpeg" alt="Thermomix Kochkurs Krefeld - Gemeinsam kochen lernen" className="w-full h-48 object-cover" />
            <div className="p-8">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mb-6 -mt-14 relative z-10 border-4 border-white shadow-lg"><PlayCircle className="w-8 h-8" /></div>
            <h4 className="text-xl font-bold mb-4 font-[Outfit]">Themen-Kochkurse</h4>
            <p className="text-slate-500 text-sm leading-relaxed mb-8">
              Ob Back-Workshops, "Meal Prep für Krefelder Familien" oder "Gesund & Fit". Lerne in meinen Kursen, wie du das Beste aus deinem Thermomix® herausholst. Live in Krefeld oder via Zoom.
            </p>
            <button
              onClick={() => { const el = document.getElementById("kochkurs-termine"); if (el) el.scrollIntoView({ behavior: "smooth" }); }}
              className="w-full py-3 border-2 border-stone-200 rounded-full font-semibold text-slate-700 hover:border-emerald-500 hover:text-emerald-600 transition">Termine ansehen</button>
            </div>
          </div>
          <div className="glass-card rounded-[2rem] p-8 hover-lift">
            <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center mb-6"><BookOpen className="w-8 h-8" /></div>
            <h4 className="text-xl font-bold mb-4 font-[Outfit]">Exklusive E-Books</h4>
            <p className="text-slate-500 text-sm leading-relaxed mb-8">
              Speziell von mir kuratierte Rezeptsammlungen, die perfekt auf regionale Zutaten und saisonale Highlights in NRW abgestimmt sind. Ein Muss für jeden TM7-Besitzer.
            </p>
            <button className="w-full py-3 border-2 border-stone-200 rounded-full font-semibold text-slate-700 hover:border-emerald-500 hover:text-emerald-600 transition">E-Books laden</button>
          </div>
          <div className="glass-card rounded-[2rem] p-8 opacity-75">
            <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center mb-6"><Mic className="w-8 h-8" /></div>
            <h4 className="text-xl font-bold mb-4 font-[Outfit]">Genuss-Podcast</h4>
            <p className="text-slate-500 text-sm leading-relaxed mb-8 italic">
              Demnächst verfügbar: Mein Podcast über Kochen, Zeitmanagement und den Lifestyle rund um den Thermomix® in Krefeld.
            </p>
            <button className="w-full py-3 bg-stone-100 text-slate-400 rounded-full font-semibold cursor-not-allowed">Coming Soon</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KurseSection;
